import { useEffect, useState } from 'react';
import '@/App.css';
import { api } from '@/lib/api';
import { BrowserRouter, Routes, Route, Outlet, Navigate, useParams } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import { useSmoothScroll } from '@/lib/useSmoothScroll';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import Home from '@/pages/Home';
import Admin from '@/pages/Admin';
import U99Layout from '@/components/u99/U99Layout';
import U99Home from '@/pages/u99/U99Home';
import KylesMind from '@/pages/u99/KylesMind';
import U99Doctrines from '@/pages/u99/U99Doctrines';
import DoctrinePage from '@/pages/DoctrinePage';
import Tools from '@/pages/u99/Tools';
import TraceTool from '@/pages/u99/TraceTool';
import Documents from '@/pages/u99/Documents';
import Library from '@/pages/u99/Library';
import DocumentPage from '@/pages/u99/DocumentPage';
import BookPage from '@/pages/u99/BookPage';
import ChapterPage from '@/pages/u99/ChapterPage';
import EliElyWorld from '@/pages/u99/EliElyWorld';

function StudioLayout() {
  const scrollTo = useSmoothScroll('/');
  return (
    <div className="App bg-[#02040a] text-slate-100" data-testid="app-root">
      <Navbar onNavigate={scrollTo} />
      <Outlet context={{ scrollTo }} />
      <Footer onNavigate={scrollTo} />
    </div>
  );
}

const LegacyDoctrine = () => {
  const { slug } = useParams();
  return <Navigate to={slug ? `/u99/doctrines/${slug}` : '/u99/doctrines'} replace />;
};

// Short links: /<slug> resolves to the standalone publication page when a published document with that slug exists.
const ShortLink = () => {
  const { slug } = useParams();
  const [to, setTo] = useState(null);
  useEffect(() => {
    api.get(`/documents/${slug}`).then(() => setTo(`/u99/documents/${slug}`)).catch(() => setTo('/'));
  }, [slug]);
  return to ? <Navigate to={to} replace /> : null;
};

function App() {
  return (
    <BrowserRouter>
      <Toaster theme="dark" position="bottom-right" />
      <Routes>
        <Route element={<StudioLayout />}>
          <Route path="/" element={<Home />} />
        </Route>
        <Route path="/u99" element={<U99Layout />}>
          <Route index element={<U99Home />} />
          <Route path="mind" element={<KylesMind />} />
          <Route path="doctrines" element={<U99Doctrines />} />
          <Route path="doctrines/:slug" element={<DoctrinePage />} />
          <Route path="tools" element={<Tools />} />
          <Route path="tools/trace" element={<TraceTool />} />
          <Route path="documents" element={<Documents />} />
          <Route path="library" element={<Library />} />
          <Route path="documents/:slug" element={<DocumentPage />} />
          <Route path="book/:slug" element={<BookPage />} />
          <Route path="book/:slug/:chapter" element={<ChapterPage />} />
          <Route path="world/eli-and-ely" element={<EliElyWorld />} />
        </Route>
        <Route path="/doctrines" element={<LegacyDoctrine />} />
        <Route path="/doctrines/:slug" element={<LegacyDoctrine />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/:slug" element={<ShortLink />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
